import React, {useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './ChoixSiegePage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useNavigate} from "react-router-dom";

const ChoixSiegePage: React.FC = ({}) => {
    const navigate = useNavigate()

    const [choice, setChoice] = useState<string | null>(null)

    return (
        <BasePage showLogo showHistorique showPanier>
            <p className="choixSiegePageText">Saisissez le siège auquel vous vous trouvez</p>
            <p className="choixSiegePageSubText">Votre numéro de siège figure sur votre billet.</p>
            <input className="choixSiegePageInput" placeholder="Ex: 102" onKeyUp={(e: any) => setChoice(e.target.value)}/>
            <BaseButton onClick={() => navigate('/menu')} text="Valider" className="choixSiegePageBtn" disabled={!choice}/>
        </BasePage>
    )
}

export default ChoixSiegePage;
